import React from "react";
import Heading from "../heading/Heading";

class HeadingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error("Business Victoria: Heading failed to render", error);
  }

  renderFallback() {
    const data = this.props.headingData || { type: "none", heading: "" };

    return (
      <section id="heading">
        <div className="container">
          <div className="row">
            <div className="col-12 main-heading">
              <h1>{data.heading}</h1>
              {data.description && <p>{data.description}</p>}
            </div>
          </div>
        </div>
      </section>
    );
  }

  render() {
    if (this.state.hasError) {
      return this.renderFallback();
    }

    return (
      <Heading
        Data={this.props.headingData}
        linkBoxData={this.props.linkBoxData}
        breadcrumbsData={this.props.breadcrumbsData}
        secondaryNavMobData={this.props.secondaryNavMobData}
      />
    );
  }
}

export default HeadingErrorBoundary;
